module.exports = __webpack_public_path__ + "files/45aa6fc13b986e227b330b983cd694ca.png";